import React from "react";

interface GuestSignHeaderProps {
  handleSubmitSignatures: () => void;
}

const GuestSignHeader: React.FC<GuestSignHeaderProps> = ({
  handleSubmitSignatures,
}) => {
  return (
    <div className="top top_bar_flx">
      <div className="top_bar_tittle">
        <h1 className="text-xl font-bold">Sign Document</h1>
      </div>
    </div>
  );
};

export default GuestSignHeader;
